export const LedgerAccountType = {
  AVAILABLE: "AVAILABLE",
  LOCKED_TRADE: "LOCKED_TRADE",
  LOCKED_AD: "LOCKED_AD",
  LOCKED_TRANSFER: "LOCKED_TRANSFER",
  LOCKED_WITHDRAWAL: "LOCKED_WITHDRAWAL",
  FEE: "FEE",
  TREASURY: "TREASURY",
  MINT_POOL: "MINT_POOL",
  PENDING_DEPOSIT: "PENDING_DEPOSIT",
  PENDING_WITHDRAWAL: "PENDING_WITHDRAWAL",
  HOT_WALLET: "HOT_WALLET",
  COLD_WALLET: "COLD_WALLET",
  BLOCKCHAIN_CLEARING: "BLOCKCHAIN_CLEARING",
} as const;

export type LedgerAccountType =
  (typeof LedgerAccountType)[keyof typeof LedgerAccountType];

export type LedgerAccount = {
  id: string;
  availableBalance: number;
  lockedBalance: number;
  pendingBalance: number;
  balance: number;
  walletId: string;
  assetId: string;
  type: LedgerAccountType;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
};
